<template>
  <div>
    <div id="app">
      <div>
        <div class="bouncefix"></div>
        <router-view class="pageview" />
        <NavBar v-if="!keyboard"></NavBar>
      </div>
    </div>
    <modal />
  </div>
</template>

<script>
/* NPM IMPORTS */
import Parse from "parse";
import http from "http";
/* JS IMPORTS */
import * as CCParse from "@/utilities/parse.js";
window.CCParse = CCParse;
import * as nativeLink from "./utilities/nativeLink";
/* COMPONENT IMPORTS */
import NavBar from "./components/Layout/Navbar.vue";
import Modal from "./components/Layout/Modal.vue";
export default {
  name: "app",
  components: {
    NavBar,
    Modal,
  },
  data() {
    return {
      shouldShowWalk: true,
      keyboard: false,
      currentReward: null,
      currentStep: -1,
      myCallbacks: {
        onPreviousStep: this.previousStep,
        onNextStep: this.nextStep,
      },
    };
  },
  beforeMount() {
    // SplashScreen.hide();
    //   $_('preloader').style.display = 'none'
  },
  async mounted() {
    let currentBg = getCssVar("layout-bg");
    $_("preloader").style.display = "none";
    $$("[data-statusbar-color]").forEach((x) => x.attr("content", currentBg));
    setInterval(
      () =>
        currentBg !== getCssVar("layout-bg")
          ? $$("[data-statusbar-color]").forEach((x) =>
              x.attr("content", getCssVar("layout-bg"))
                ? null
                : x.attr("content", currentBg)
            )
          : null,
      1000
    );
    let resizeTimer;
    window.addEventListener("resize", () => {
      document.body.classList.add("resize-animation-stopper");
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        document.body.classList.remove("resize-animation-stopper");
      }, 400);
    });
    const _this = this;
    await this.$root.initLoadChores();
    window.Parse = Parse;

    let hasOpenedApp;
    hasOpenedApp = setInterval((x) => {
      if (Parse.User.current()) {
        clearInterval(hasOpenedApp);
        const logins = Parse.User.current().get("logins");
        logins == undefined
          ? Parse.User.current().set("logins", [Date(Date.now)])
          : (() => {
              logins.push(Date(Date.now));
              Parse.User.current().set("logins", logins);
            })();
        Parse.User.current().save();
      }
    });
  },
  watch: {
    "$root.$data.locked": async function (updated, old) {},
  },
};
</script>

<style lang="scss">
@import "./styles/main.scss";

.pageview {
  -webkit-overflow-scrolling: touch;
  overflow: scroll;
  padding-top: 0;
  grid-template-rows: auto 1fr;
  height: 100vh;
}
.oneui {
  background: var(--layout-bg);
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
  -webkit-overflow-scrolling: touch;
}

.bouncefix {
  position: fixed;
  z-index: -1;
  width: 100%;
  height: 100vw;
  background: linear-gradient(
    var(--layout-bg) 0%,
    var(--layout-bg) 50%,
    var(--theme-color-1) 100%
  );
}
</style>
